import { Component, OnInit, ViewChild } from '@angular/core';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { SolicitudResultadoBusqueda } from 'src/app/models/solicitud/solicitudResultadoBusqueda';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { SedeService } from 'src/app/services/sede/sede.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { EstadoSolicitud, ParametrosMaestro, TipoFiltro, eTypeResult } from 'src/app/models/common/enumModel';
import { IFilterSolicitudModel } from 'src/app/models/interfaces/solicitud/IFilterSolicitudModel';
import { MatPaginator } from '@angular/material/paginator';
import { FilterSolicitudModel } from 'src/app/models/solicitud/FilterSolicitudModel';
import { SolicitudService } from 'src/app/services/solicitud/solicitud.service';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import * as fileSaver from 'file-saver';
import { SolicitudAmpliarPersonalModel } from 'src/app/models/solicitud/SolicitudAmpliarPersonalModel';
import { MatDialog } from '@angular/material/dialog';
import { SolicitudAmpliarPersonalComponent } from '../../solicitud-ampliar-personal/solicitud-ampliar-personal.component';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-solicitud-contratista-lista',
  templateUrl: './solicitud-contratista-lista.component.html',
  styleUrls: ['./solicitud-contratista-lista.component.css'],
})
export class SolicitudContratistaListaComponent implements OnInit {
  displayedColumns: string[] = [
    'codigo',
    'compania',
    'trabajo',
    'fecha',
    'solicitante',
    'sede',
    'tipoCreacion',
    'estado',
    'acciones',
  ]; // 'contacto',
  listaSolicitudes: SolicitudResultadoBusqueda[] = new Array<SolicitudResultadoBusqueda>();
  listaSedes: SedeModel[] = new Array<SedeModel>();
  listaEstadosSolicitud: ParametroModel[] = new Array<ParametroModel>();
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();

  model: IFilterSolicitudModel;
  resultsLength = 0;
  currentPage = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  @ViewChild('paginator') paginator!: MatPaginator;

  constructor(
    private solicitudService: SolicitudService,
    private sedeService: SedeService,
    public dialog: MatDialog,
    private storage: StorageService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
    private parametroService: ParametroService
  ) {
    this.model = new FilterSolicitudModel();
    //No se asignan fechas para la bandeja
    //this.model.fechaInicio = this.addDays(new Date(), -14);
    //this.model.fechaFin = new Date();
    let usuario = this.storage.getCurrentUser();
    this.model.pageSize = 30;
    this.model.estados = [];//[EstadoSolicitud.SOLICITADO, EstadoSolicitud.OBSERVADO, EstadoSolicitud.EN_REVISION, EstadoSolicitud.REVISADO, EstadoSolicitud.PROGRAMACION_INDUCCION, EstadoSolicitud.RESULTADOS_INDUCCION, EstadoSolicitud.AUTORIZACION_ACCESOS, EstadoSolicitud.FINALIZADO, EstadoSolicitud.RECHAZADO];
    this.model.idTipoFiltro = TipoFiltro.TODAS;
    this.listaCompanias = usuario.companias;
    this.model.idCompania = usuario.companiaDefault.idCompania;
  }

  ngOnInit(): void {
    this.solicitudService
      .getListContratista(this.model)
      .subscribe((data: SearchResultModel<SolicitudResultadoBusqueda[]>) => {
        this.listaSolicitudes = data.items;
      });

    this.companiaChanged();
    this.parametroService
      .getDetalles(ParametrosMaestro.EstadosSolicitudes)
      .subscribe((data: SearchResultModel<ParametroModel[]>) => {
        this.listaEstadosSolicitud = data.items.filter(p =>
          p.idParametroDetalle !== EstadoSolicitud.EN_ELABORACION
        );
      });
  }

  companiaChanged() {

    this.listaSedes = [];
    this.model.sedes = [];
    let filterSede: IFilterSedeModel = new FilterSedeModel();
    filterSede.companias.push(this.model.idCompania);

    this.sedeService
      .getList(filterSede)
      .subscribe((data: SedeModel[]) => {
        this.listaSedes = data;
      });
  }

  getPaginatorData(event: any) {
    this.model.page = event.pageIndex + 1;
    this.model.pageSize = event.pageSize;
    this.solicitudService
      .getListContratista(this.model)
      .subscribe((data: SearchResultModel<SolicitudResultadoBusqueda[]>) => {
        this.listaSolicitudes = data.items;
        this.resultsLength = data.total;
      });
  }

  search() {
    this.model.page = 1;
    this.solicitudService
      .getListContratista(this.model)
      .subscribe((data: SearchResultModel<SolicitudResultadoBusqueda[]>) => {
        this.listaSolicitudes = data.items;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  addDays(currentDate: Date, days: number): Date {
    currentDate.setDate(currentDate.getDate() + days);
    return currentDate;
  }

  delete(item: SolicitudResultadoBusqueda) {
    this.confirmDialogService.open(`¿Está seguro de borrar todos los datos de la solicitud ${item.codigo}?`); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.solicitudService.delete(item.idSolicitud).subscribe((result) => {
          if (result.type == eTypeResult.SUCCESS) {
            this.search();
            this.alertDialogService.open('La solicitud fue eliminada');
          }
          else {
            this.alertDialogService.open(result.message);
          }
        });
      }
    });
  }

  export() {
    //this.paginator.pageIndex = 0;
    this.model.page = 1;
    // this.model.pageSize = this.paginator.pageSize;
    this.solicitudService.getListContratistaToExport(this.model).subscribe(
      (data) => {
        // console.log(data.headers.get('content-disposition'));
        // console.log(data.headers);
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        const url = window.URL.createObjectURL(blob);

        //window.open(url);
        //window.location.href = response.url;
        fileSaver.saveAs(blob, `solicitudes-contratista-${Date.now()}.xlsx`);

        //  this.createImageFromBlob(data);
        //  this.isImageLoading = false;
      },
      (error) => {
        //  this.isImageLoading = false;
        //  console.log(error);
      }
    );
  }

  isOldDate(fechaElva: string): Boolean {
    let fecha = new Date(fechaElva);
    let current = new Date();
    current.setHours(0, 0, 0, 0)
    return fecha >= current;
  }

  openDialogAmpliarPersonal(solicitud: SolicitudResultadoBusqueda): void {
    // if(!extensionModel)
    // console.log(solicitud);
    let amplicarPersonalModel = new SolicitudAmpliarPersonalModel();
    amplicarPersonalModel.idSolicitud = solicitud.idSolicitud;

    const dialogRef = this.dialog.open(SolicitudAmpliarPersonalComponent, {
      width: '500px',
      // data: { name: this.name, animal: this.animal}
      data: amplicarPersonalModel
    });

    dialogRef.afterClosed().subscribe(result => {
      // this.animal = result;
      // console.log(result);
      // this.service.submit(result).subscribe(p => {
      //   console.log(p);
      // });
      this.search();
    });
  }
}
